import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=2f1399d7&scoped=true&"
import script from "./ProcessMIIP.vue?vue&type=script&lang=js&"
export * from "./ProcessMIIP.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=2f1399d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1399d7",
  null
  
)

export default component.exports